<template>
  <BaseScreen v-bind="screen">
    <template #actions>
      <BaseButton
        v-if="hasTickets"
        :text="$t('actions.clearCart')"
        size="xs"
        is-outlined
        @click="showModal"
      />
    </template>
    <Cart
      v-if="hasTickets"
      :event="event"
      :tickets="tickets"
      :sum="sum"
      @remove="removeTicketById"
    />
    <BaseAlert
      v-else
      v-bind="empty"
      slot="middle"
    />
    <ModalConfirm
      v-if="isModalVisible"
      v-bind="modal"
      slot="root"
      class="screen__overlay"
      @agree="clear"
      @disagree="hideModal"
    />
  </BaseScreen>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

import screenMixin from '@/mixins/screen';
import BaseButton from '@/components/BaseButton.vue';
import ModalConfirm from '@/components/ModalConfirm.vue';
import Cart from '@/components/Cart.vue';

import CONSTANTS from '@/helpers/constants';

const {
  ACTION_OPEN_CONFIRM_MODAL,
  ACTION_CONFIRM_CART_CLEAN,
  ACTION_CANCEL_CART_CLEAN,
  STEP_MODAL_CONFIRM_CART_CLEAN,
} = CONSTANTS;

export default {
  name: 'CartScreen',
  mixins: [screenMixin],
  components: {
    BaseButton,
    ModalConfirm,
    Cart,
  },
  data() {
    return {
      isModalVisible: false,
    };
  },
  computed: {
    ...mapState('cart', [
      'event',
      'tickets',
    ]),
    ...mapGetters('cart', [
      'sum',
      'ticketsCount',
    ]),
    title() {
      return this.$t('titles.cart');
    },
    empty() {
      return {
        icon: {
          name: 'tickets',
          isPied: true,
        },
        title: this.$t('titles.emptyCart'),
        actions: [
          {
            text: this.$t('actions.home'),
            action: () => this.$router.push(this.$router.options.paths.home),
          },
          {
            text: this.$t('actions.buyTicket'),
            action: () => this.$router.push(this.$router.options.paths.events),
          },
        ],
      };
    },
    modal() {
      return {
        title: this.$t('titles.confirmClearCart'),
        agreeText: this.$t('actions.yes'),
        disagreeText: this.$t('actions.no'),
        replic: STEP_MODAL_CONFIRM_CART_CLEAN,
      };
    },
    hasTickets() {
      return this.event && this.ticketsCount > 0;
    },
  },
  mounted() {
    this.initActions();
  },
  methods: {
    ...mapMutations('cart', [
      'removeTicketById',
    ]),
    ...mapActions('cart', [
      'tryToCancelOrder',
      'clearAll',
    ]),
    clear() {
      this.tryToCancelOrder();
      this.clearAll();
      this.hideModal();
    },
    showModal() {
      this.isModalVisible = true;
    },
    hideModal() {
      this.isModalVisible = false;
    },
    initActions() {
      const rootActions = [
        [ACTION_OPEN_CONFIRM_MODAL, this.showModal],
        [ACTION_CONFIRM_CART_CLEAN, this.clear],
        [ACTION_CANCEL_CART_CLEAN, this.hideModal],
      ];

      rootActions.forEach((action) => this.$root.$on(...action));

      this.$once('hook:beforeDestroy', () => {
        rootActions.forEach((action) => this.$root.$off(...action));
      });
    },
  },
};
</script>
